import React from 'react';
import PropTypes from 'prop-types';

import { Location as LocationModel } from 'models/locations';
import SellerModel from 'models/seller';

export default function SellerLogo({ location, seller }) {
  if (!location.displaySellerLogo || (!location.sellerLogo && !seller.logo)) { return null; }

  const logo = location.sellerLogo ? location.sellerLogo.imageSizes.get('logo') : seller.logo.imageSizes.get('logo');

  return <img src={logo.url} alt={seller.name} className="with-vertical-margin-half" />;
}

SellerLogo.propTypes = {
  location:  PropTypes.instanceOf(LocationModel).isRequired,
  seller:  PropTypes.instanceOf(SellerModel).isRequired,
};
